/**
 * Message Types for communication with the Orbit Cruncher Worker
 * These must match those in orbitCruncher.ts
 */
export var OrbitCruncherMsgType;
(function (OrbitCruncherMsgType) {
    OrbitCruncherMsgType[OrbitCruncherMsgType["INIT"] = 0] = "INIT";
    OrbitCruncherMsgType[OrbitCruncherMsgType["UPDATE"] = 1] = "UPDATE";
    OrbitCruncherMsgType[OrbitCruncherMsgType["CHANGE_ORBIT_TYPE"] = 2] = "CHANGE_ORBIT_TYPE";
    OrbitCruncherMsgType[OrbitCruncherMsgType["MISSILE_UPDATE"] = 3] = "MISSILE_UPDATE";
    OrbitCruncherMsgType[OrbitCruncherMsgType["SATELLITE_UPDATE"] = 4] = "SATELLITE_UPDATE";
    OrbitCruncherMsgType[OrbitCruncherMsgType["SETTINGS_UPDATE"] = 5] = "SETTINGS_UPDATE";
    OrbitCruncherMsgType[OrbitCruncherMsgType["RESPONSE_READY"] = 6] = "RESPONSE_READY";
    OrbitCruncherMsgType[OrbitCruncherMsgType["RESPONSE_DATA"] = 7] = "RESPONSE_DATA";
})(OrbitCruncherMsgType || (OrbitCruncherMsgType = {}));
export var OrbitDrawTypes;
(function (OrbitDrawTypes) {
    OrbitDrawTypes[OrbitDrawTypes["ORBIT"] = 0] = "ORBIT";
    OrbitDrawTypes[OrbitDrawTypes["TRAIL"] = 1] = "TRAIL";
})(OrbitDrawTypes || (OrbitDrawTypes = {}));
